var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[_vm.labelClass, 'timeri18n-label'],attrs:{"id":"timer-remaining-time-string"}},[_vm._v(" "+_vm._s((_vm.inTranslation + " " + _vm.remainingTimeString))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }